import { render } from "./JanVegas.vue?vue&type=template&id=a10ffff6"
import script from "./JanVegas.vue?vue&type=script&lang=js"
export * from "./JanVegas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__